<div class="container margin">
  <form [formGroup]="formEquipos" (ngSubmit)="formEquipos.valid?saveEquipo(formEquipos.value):errorMessage()">
    <div style='display: flex; width: 100%; '>

      <div style='flex:10'>

        <mat-tab-group>
          <mat-tab label="Informacion">
            <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">

              <div class='first-row'>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='code' matInput #codigo maxlength="255"
                      required placeholder="Código">
                    <mat-hint>{{codigo.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='brand' matInput #marca maxlength="255"
                      required placeholder="Marca">
                    <mat-hint>{{marca.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item-button'>
                  <div style='width:100%;'>
                    <combos [control]="formEquipos.get('equipmenTypeId')" [configuration]='combosConfigEquipmentType' [reloadCombo]='reloadComboEquipmentType'
                      [required]="true" [filter]="true">
                    </combos>
                  </div>

                  <div *ngIf='tipoRedireccion!="update"' style='min-width: 24px; max-width: 24px; cursor:pointer;'>
                    <div (click)='addNew("tipo de equipo")' matRipple>
                      <mat-icon>add_circle</mat-icon>
                    </div>
                  </div>
                </div>

              </div>

              <div class='default-row'>

                <div class='row-item'>
                  <combos  [control]="formEquipos.get('userId')" [configuration]='combosConfigResponsable' [reloadCombo]='reloadComboResponsable'
                    [required]="true" [filter]="true">
                  </combos>
                </div>

                <div class='row-item-button'>
                  <div style='width:100%;'>
                    <combos [control]="formEquipos.get('areaId')" [configuration]='combosConfigArea' [reloadCombo]='reloadComboArea' [required]="true"
                      [filter]="true">
                    </combos>
                  </div>
                  <div *ngIf='tipoRedireccion!="update"' style='min-width: 24px; max-width: 24px; cursor:pointer;'>
                    <div (click)='addNew("area")' matRipple>
                      <mat-icon>add_circle</mat-icon>
                    </div>
                  </div>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="number" matInput formControlName='currentOdometer' #odometro
                      oninput="this.value = this.value.slice(0,7)" placeholder="Odómetro/Horómetro actual">
                    <mat-hint>{{odometro.value.length}}/7</mat-hint>
                  </mat-form-field>
                </div>

              </div>

              <div class='default-row'>

                <div class="row-item">
                  <mat-form-field>
                    <mat-label>Equipo de alquiler</mat-label>
                    <mat-select formControlName="isRental">
                      <mat-option [value]="1">Si</mat-option>
                       <mat-option [value]="0">No</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>


                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="number" matInput formControlName='rentalCost' #rentalCosto
                      oninput="this.value = this.value.slice(0,10)" placeholder="Costo de equipo">
                    <mat-hint>{{rentalCosto.value.length}}/10</mat-hint>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='warranty' matInput #garantia maxlength="255"
                      placeholder="Garantia">
                    <mat-hint>{{garantia.value.length}}/255</mat-hint>
                  </mat-form-field>
                </div>

              </div>
              <div class="default-row">

                <div class='row-item'>
                  <mat-form-field>
                    <mat-label>Fecha compra</mat-label>
                    <input matInput [matDatepicker]="pickerCompra" autocomplete="off" matInput
                      formControlName='purchaseDate'>
                    <mat-datepicker-toggle matSuffix [for]="pickerCompra">
                    </mat-datepicker-toggle>
                    <mat-datepicker #pickerCompra [touchUi]='movil?true:false'></mat-datepicker>
                  </mat-form-field>
                </div>

                <div class="row-item">
                  <file-input [params]='fileInputEquipo' (fileSave)='fileSaveEquipo($event)'></file-input>
                </div>

              </div>

            </cdk-virtual-scroll-viewport>
          </mat-tab>

          <mat-tab label="Caracteristicas">
            <cdk-virtual-scroll-viewport itemSize="100" class="example-viewport cdk">

              <div class='first-row'>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='power' matInput #potencia maxlength="255"
                      placeholder="Potencia">
                    <mat-hint>{{potencia.value.length}}/255</mat-hint>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <app-date [value]="formEquipos.controls.fabricationDate.value" class="p-0" type="year" (dateSelected)="chosenYearHandler($event)"></app-date>
                </div>

              </div>


              <div class='default-row'>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='powerSupply' matInput #alimentacion
                      maxlength="255" placeholder="Alimentacion">
                    <mat-hint>{{alimentacion.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='serial' matInput #serial maxlength="255"
                      placeholder="Serial">
                    <mat-hint>{{serial.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div class='default-row'>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='accessories' matInput #accesorios
                      maxlength="255" placeholder="Accesorios">
                    <mat-hint>{{accesorios.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='color' matInput #color maxlength="255"
                      placeholder="Color">
                    <mat-hint>{{color.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div>
                <div class="default-row">

                  <div class='row-item'>
                    <mat-form-field>
                      <input autocomplete="off" type="text" formControlName='aplication' matInput #aplicacion
                        maxlength="255" placeholder="Aplicacion">
                      <mat-hint>{{aplicacion.value.length}}/255</mat-hint>
                      <mat-error>Campo requerido</mat-error>
                    </mat-form-field>
                  </div>

                  <div class="row-item" *ngIf="tipoRedireccion == 'new'">
                    <mat-form-field>
                      <mat-label>Componentes</mat-label>
                      <mat-select (selectionChange)="seleccionadosComponentes($event)">
                        <mat-option *ngFor="let number of numeroComponentes" [value]="number">{{number}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                </div>
              </div>

              <div class='default-row'>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='providerName' matInput #proveedor
                      maxlength="255" placeholder="Proveedor">
                    <mat-hint>{{proveedor.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

                <div class='row-item'>
                  <mat-form-field>
                    <input autocomplete="off" type="text" formControlName='description' matInput #descripcion
                      maxlength="255" placeholder="Descripcion">
                    <mat-hint>{{descripcion.value.length}}/255</mat-hint>
                    <mat-error>Campo requerido</mat-error>
                  </mat-form-field>
                </div>

              </div>

            </cdk-virtual-scroll-viewport>
          </mat-tab>

          <mat-tab label='Componentes' *ngIf="tipoRedireccion == 'update'">
            <div style="margin: 30px">
              <data-table [title]='titleComponentes' [columns]='columnasComponentes' [data]='dataComponentes'
                [configuration]='configurationComponentes' [reloadTable]='recargarTablaComponentes'
                (add)='agregarComponentes($event)' (edit)='editarComponentes($event)'
                (delete)='eliminarComponentes($event)' (selection)='seleccionadosComponentes($event)'
                (clickRow)='clickFilaComponentes($event)' [url]='urlGetComponentes'
                [params]='paramsCompoentes'></data-table>
            </div>
          </mat-tab>

        </mat-tab-group>

      </div>

      <!-- botones -->
      <div style='flex:.2'>
        <button [disabled]="buttonEnd" mat-mini-fab color="warn" type="submit">
          <mat-icon>save</mat-icon>
        </button>

        <button *ngIf='tipoRedireccion=="update"' mat-mini-fab color="accent" (click)='deleteEquipo($event)'
          style='margin-top: 10px;'>
          <mat-icon>delete</mat-icon>
        </button>

        <button mat-mini-fab color="primary" (click)='back($event)' style='margin-top: 10px;'>
          <mat-icon>reply</mat-icon>
        </button>

      </div>

    </div>
  </form>
</div>
